// extracted by mini-css-extract-plugin
export default {"infoItemsContainer":"InfoItems_infoItemsContainer__vLG10","infoItem":"InfoItems_infoItem__YP4EL"};